import { render, staticRenderFns } from "./TestJSONListModal.vue?vue&type=template&id=2c52cade"
import script from "./TestJSONListModal.vue?vue&type=script&lang=js"
export * from "./TestJSONListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports